import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Link, useNavigate } from 'react-router-dom';
import AuthService from '../services/AuthService';
import logo from '../assets/images/logo.png';
import ApiService from "../services/ApiService";
import CheckInOut from './CheckInOut';
import { getDefaultAdminRoute } from '../utils/permissions';
import { toast } from 'react-toastify';
import moment from 'moment';


const Header = () => {
    const navigate = useNavigate();
    const [user] = useState(JSON.parse(localStorage.getItem('admin')));
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);


    const handleLogoutClick = () => {
        setShowLogoutModal(true);
    };

    const handleLogoutConfirm = () => {
        AuthService.logout();
        setShowLogoutModal(false);
    };

    const handleLogoutCancel = () => {
        setShowLogoutModal(false);
    };
    useEffect(() => {
        getNotifications();
        const interval = setInterval(getNotifications, 30000);
        return () => clearInterval(interval);
    }, []);


    const getNotifications = async () => {
        try {
            const response = await ApiService.request({
                method: "GET",
                url: "admin/getNotifications",
                params: { page: 1, limit: 15 }
            });
            const data = response.data;
            if (data.status) {
                if(data.data?.map_key) {
                    localStorage.setItem('map_key', data.data.map_key);
                }
                setNotifications(data.data?.notifications || []);
                setUnreadCount(data.data?.unread_count || 0);
            }
           
            // if(data.)
        } catch (error) {
            console.log('Error fetching notifications:', error);
        }
    };

    return (
        <>
        <div id="kt_app_header" className="app-header bg-white">
            <div className="app-container container-fluid d-flex align-items-stretch justify-content-between" id="kt_app_header_container">
                <div className="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show sidebar menu">
                    <div className="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_sidebar_mobile_toggle">
                        {/* Dark icon so it stays visible on the white header. */}
                        <i className="bi bi-list text-dark fs-1"></i>

                    </div>
                </div>
                <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
                    <Link to={getDefaultAdminRoute()} className="d-lg-none rounded">
                        <img alt="Logo" src={logo} className="h-50px" style={{ maxHeight: '30px' }} />
                    </Link>
                </div>
                {/* <div className="search header-search">
                    <h2>Welcome to Admin</h2>
                    <p>Manage entire application</p>
                </div> */}

                <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1" id="kt_app_header_wrapper">
                    <div className="app-header-menu app-header-mobile-drawer align-items-stretch">
                        <div className="menu menu-rounded menu-column menu-lg-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0" id="kt_app_header_menu" data-kt-menu="true">
                            {/* Add Menu Items */}
                        </div>
                    </div>
                    <div className="app-navbar flex-shrink-0 align-items-center">
                    <div className="app-navbar-item ms-1 ms-lg-3">
                        </div>

                        {/* Check in / check out for the signed-in admin */}
                        <CheckInOut />

                        {/* Notification Bell */}
                        <div
                            className="app-navbar-item ms-1 ms-lg-3 position-relative"
                            onMouseEnter={() => setShowNotifications(true)}
                            onMouseLeave={() => setShowNotifications(false)}
                        >
                            <div
                                className="btn btn-icon btn-custom btn-active-dark btn-active-color-dark w-35px h-35px w-md-40px h-md-40px position-relative"
                                onClick={() => {
                                    navigate('/admin/notifications');
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <i className='bi bi-bell-fill text-gray-500 fs-2'></i>
                                {notifications.length > 0 &&
                                    <span className="bullet bullet-dot h-20px w-20px position-absolute translate-middle top-5 start-75 bg-danger text-white">
                                   <small>{notifications.length}</small> </span>
                                }
                            </div>

                            {/* Notification Dropdown */}
                            <div
                                style={{
                                    position: 'absolute',
                                    top: 'calc(100% + 10px)',
                                    right: 0,
                                    background: '#fff',
                                    borderRadius: 8,
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                    border: '1px solid #e5e7eb',
                                    width: 340,
                                    zIndex: 107,
                                    opacity: showNotifications ? 1 : 0,
                                    visibility: showNotifications ? 'visible' : 'hidden',
                                    transform: showNotifications ? 'translateY(0)' : 'translateY(-10px)',
                                    transition: 'all 0.25s ease',
                                    overflow: 'hidden',
                                }}
                            >
                                <div className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
                                    <span className="fw-bold text-dark fs-6">Notifications</span>
                                    {unreadCount > 0 && (
                                        <span className="badge badge-light-danger">{unreadCount} new</span>
                                    )}
                                </div>

                                <div style={{ maxHeight: 360, overflowY: 'auto' }}>
                                    {notifications.length > 0 ? (
                                        notifications.map((notification, index) => (
                                            <div
                                                key={notification._id || index}
                                                className="px-4 py-3 border-bottom"
                                            >
                                                <div className="d-flex align-items-start justify-content-between">
                                                    <span className="text-dark fw-semibold fs-7 me-2">{notification.title}</span>
                                                    <small className="text-muted text-nowrap">
                                                        {moment(notification.createdAt).fromNow()}
                                                    </small>
                                                </div>
                                                <p className="text-gray-600 mb-0 mt-1" style={{ fontSize: '0.85rem', lineHeight: 1.4 }}>
                                                    {notification.message}
                                                </p>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-center py-8">
                                            <i className="bi bi-bell-slash fs-2x text-gray-400 d-block mb-3"></i>
                                            <span className="text-gray-500 fs-7">No notifications</span>
                                        </div>
                                    )}
                                </div>

                                <div className="px-4 py-3 border-top text-center">
                                    <Link
                                        to="/admin/notifications"
                                        className="text-primary fw-semibold fs-7"
                                        onClick={() => setShowNotifications(false)}
                                    >
                                        View All Notifications
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="app-navbar-item ms-1 ms-lg-3 position-relative" id="kt_header_user_menu_toggle">
                            <div className="cursor-pointer symbol symbol-35px symbol-md-40px profile-dropdown position-relative">
                                <img src={user?.picture} alt="user" />
                                <div className="header-profile-popup">
                                    <div className="header-profile-content">
                                        <div className="header-profile-info">
                                            <div className="header-profile-avatar">
                                                <img alt="Profile" src={user?.picture} />
                                            </div>
                                            <div className="header-profile-details">
                                                <div className="header-profile-name">{user?.name || 'Elite Cuts Barbershop'}</div>
                                                <div className="header-profile-email">{user?.email || 'devicebee@gmail.com'}</div>
                                            </div>
                                        </div>
                                        <div className="header-profile-separator"></div>
                                        <div className="header-profile-menu">
                                            <div className="header-profile-menu-item">
                                                <Link to="/admin/account">Account Settings</Link>
                                            </div>
                                            <div className="header-profile-menu-item">
                                                <button onClick={handleLogoutClick} className="logout-btn-header">Logout</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="app-navbar-item d-none ms-2 me-n3" title="Show header menu">
                            <div className="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_header_menu_toggle">
                                {/* SVG Icon */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        {showLogoutModal && ReactDOM.createPortal(
            <>
                {/* Full-viewport overlay */}
                <div
                    onClick={handleLogoutCancel}
                    style={{
                        position: 'fixed', inset: 0,
                        background: 'rgba(0,0,0,0.55)',
                        zIndex: 99998,
                        backdropFilter: 'blur(2px)',
                    }}
                />
                {/* Centered dialog */}
                <div
                    style={{
                        position: 'fixed', inset: 0,
                        zIndex: 99999,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        pointerEvents: 'none',
                    }}
                >
                    <div
                        style={{
                            background: '#fff',
                            borderRadius: 16,
                            boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
                            width: '100%', maxWidth: 400,
                            padding: '2rem',
                            pointerEvents: 'auto',
                            textAlign: 'center',
                        }}
                    >
                        {/* Icon */}
                        <div style={{
                            width: 64, height: 64, borderRadius: '50%',
                            background: '#F2F8FEff', margin: '0 auto 1.25rem',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <i className="bi bi-box-arrow-right text-base" style={{ fontSize: 28,}}></i>
                        </div>
                        <h5 style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: '0.5rem' }}>
                            Confirm Logout
                        </h5>
                        <p style={{ color: '#6c757d', fontSize: 14, marginBottom: '1.75rem' }}>
                            Are you sure you want to log out of your session?
                        </p>
                        <div className="d-flex gap-3 justify-content-center">
                            <button
                                className="btn btn-light fw-semibold px-4"
                                style={{ borderRadius: 10, minWidth: 110 }}
                                onClick={handleLogoutCancel}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn fw-semibold px-4 btn-base"
                                style={{ borderRadius: 10, minWidth: 110, }}
                                onClick={handleLogoutConfirm}
                            >
                                <i className="bi bi-box-arrow-right me-2"></i>Logout
                            </button>
                        </div>
                    </div>
                </div>
            </>,
            document.body
        )}
        </>
    );
};

export default Header;

